import React from "react";

import { AHText, Box, AHIcon } from "arkh";
import { View } from "react-native";

import { Image } from "expo-image";
import { FormattedMessage } from "react-intl";
import { encodeInvite, Invite } from "./clipboard";

const DownloadAppLink = (props: {
  platform: "iOS" | "Android";
  onPress?: () => void;
  invite?: Invite;
}) => {
  return (
    <a
      style={{ flex: 1, display: "flex", textDecoration: "none" }}
      href={
        props.platform === "Android"
          ? "https://play.google.com/store/apps/details?id=com.barkh.storesprint.main"
          : "https://apps.apple.com/se/app/storesprint/id1501873356"
      }
      onClick={() => {
        if (props.invite) {
          navigator.clipboard.writeText(encodeInvite(props.invite));
        }
      }}
    >
      <Box
        color="surface-backgroundControl"
        space="medium"
        cornerRadius="large"
        style={{
          flex: 1,
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <View>
          <AHText type="subtitle" color="darkerText">
            {props.platform}
          </AHText>
        </View>
        {props.platform === "iOS" && <AHIcon type="app-store" forceSize={20} />}
        {props.platform === "Android" && <AHIcon type="google-play" forceSize={20} />}
      </Box>
    </a>
  );
};

export function MobileOnWeb(props: { invite?: Invite }) {
  return (
    <Box
      style={{
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "row",
      }}
      color="surface"
    >
      <Box style={{ flex: 1, maxWidth: 450 }} space="medium">
        <Box
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Image
            alt="StoreSprint Icon"
            source={{
              uri: "https://assets.storesprint.app/icons/icon.png",
            }}
            contentFit="scale-down"
            style={{ width: "100%", height: 100 }}
          />
          <Box spaceBottom="xlarge">
            <AHText textAlign="center" type="subtitle" color="washedText">
              <FormattedMessage
                defaultMessage="Available for iOS and Android on phone and tablet"
                description="LoginScreen web app subtitle"
              />
            </AHText>
          </Box>
          <Box style={{ flexDirection: "column", gap: 30 }}>
            <DownloadAppLink platform="iOS" invite={props.invite} />
            <DownloadAppLink platform="Android" invite={props.invite} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
